<ng-container *clientScreen="let isDesktop = isDesktop">
	<pre>{{ opened }}</pre>
	@if (opened) {
		<div
			moveToRoot
			class="backdrop w-100 h-100 pos-fixed pos-t-0 pos-l-0 p-safe border-box bg-backdrop"
			(click)="outsideClick()"
		>
			<div class="w-100 h-100 fl fl-ai-c fl-jc-c ws-pl wb-bw">
				<div
					class="container bg-180 fl fl-dir-c fl-ai-c fl-jc-fs ov-auto shadow-menu"
					[class.desktop]="isDesktop"
					[class.full-size]="fullSize"
					[class.mobile]="!isDesktop"
					(click)="$event.stopPropagation()"
				>
					<div class="fl-fixed w-100 h-sp-2 fl fl-ai-c fl-jc-fe p-1-rl">
						<ng-content select="title"></ng-content>
						<div class="fl fl-jc-fe" style="flex: 1">
							@if (showClose) {
								<button
									uiNewButtonIcon
									size="SMALL"
									[ngStyle]="{ color: 'var(--color-text-400)' }"
									(click)="close()"
								>
									<i class="icon-cross"></i>
								</button>
							}
						</div>
					</div>
					<div class="fl-adaptable w-100 ov-auto">
						<ng-content></ng-content>
					</div>
					<ng-content select="description"></ng-content>
				</div>
			</div>
		</div>
	}
</ng-container>
